import { useCallback, useState } from "react";
import ReactModal from "react-modal";
import TierList from "../components/tierList";
import { escapeRoomList } from "../../lists/escapeRooms";

export default function EscapeRooms() {

    const [showModal, setShowModal] = useState(false);
    const handleOpenModal = useCallback((index) => {
        setShowModal(true);
    }, []);
    const handleCloseModal = useCallback((index) => {
        setShowModal(false);
    }, []);

    return (
        <>
            <div className="artwork-tape-header container">
                <div className="row">
                    <div className="col-12">
                        <div className="artwork-tape-header-titles">Escape Rooms</div>
                        <p className="align-center">Lock In Times: {escapeRoomList.length} </p>
                        <div className="gaming-tier-list-button" onClick={handleOpenModal}>
                            <div className="index-card-header">Room List</div>
                        </div>
                        <img className="usa-map" alt="escape rooms" src={process.env.PUBLIC_URL + "/images/experiences/EscapeRooms.jpg"} />
                    </div>
                </div>
            </div>
            <div className="mt-5 col-12 col-md-4">
                <ReactModal
                    isOpen={showModal}
                    contentLabel="Minimal Modal Example"
                >
                    <TierList
                        items={escapeRoomList}
                        tiers={["Won", "Lost"]}
                        columns={2}
                    />
                    <button onClick={handleCloseModal}>Close Window</button>
                </ReactModal>
            </div>
        </>
    )
}